import PropTypes from "prop-types";
import styled from "styled-components";

const StyledItemContainer = styled.div`
    padding: 2%;
    height: 3em;
    display: flex;
    cursor: ${({ $pointer }) => ($pointer ? "pointer" : "auto")};

    &:hover {
        background-color: ${({ $changeColorOnHover }) =>
            $changeColorOnHover ? "#f2f2f2" : "transparent"};
    }
`;

/**
 * Styled list item container with optional pointer cursor and hover color change.
 *
 * @param root0 - The component props.
 * @param root0.children - The list item content.
 * @param root0.pointer - Whether to show a pointer cursor.
 * @param root0.changeColorOnHover - Whether to change color on hover.
 * @returns The rendered group list item.
 */
const GroupListItem = ({ children, pointer, changeColorOnHover, ...props }) => (
    <div {...props}>
        <StyledItemContainer
            $pointer={pointer}
            $changeColorOnHover={changeColorOnHover}
        >
            {children}
        </StyledItemContainer>
    </div>
);

GroupListItem.propTypes = {
    children: PropTypes.node.isRequired,
    pointer: PropTypes.bool,
    changeColorOnHover: PropTypes.bool,
};

export default GroupListItem;
